import React, { Fragment } from "react"
import Logo from "@localComponents/logo"
import { GlobalStyles, Content, Code, Link, Text } from "./styles"

const ErrorLayout = ({ code, text }) => (
  <Fragment>
    <GlobalStyles />
    <Logo />
    <Content>
      <Code>{code}</Code>
      <Text>{text}</Text>
      {code === "404" && <Link to="/">← Home</Link>}
    </Content>
  </Fragment>
)

export default ErrorLayout
